import React, { Suspense } from "react";
import ServerSideService from "../../utilities/serverSideService";
import { IAlgoliaSearchProps } from "./algoliaSearchComponent";

const AlgoliaSearchComponent = React.lazy(
  /* webpackMode: "lazy" */
  /* webpackChunkName: "slide-outs" */
  () => import("./algoliaSearchComponent"),
);

const AlgoliaSearchProvider = (props: IAlgoliaSearchProps) => {
  // don't render on server side or if algolia config is missing
  if (ServerSideService.isServerSide || !props.algoliaConfig) {
    return null;
  }

  return (
    <Suspense fallback={<></>}>
      <AlgoliaSearchComponent {...props} />
    </Suspense>
  );
};

export default AlgoliaSearchProvider;
